<template>
<div class="offers-picklist">
  <Picklist :options="offers" v-model="selectedOffer" :disabled="!editable || !offers.length" searchable visible-items="10" />
  <button
    class="slds-m-left--x-small slds-button slds-button_icon slds-is-selected slds-button_icon-border-filled"
    :title="$t('general.add')"
    :disabled="!editable || !offers.length || !selectedOffer"
    @click="addOffer" >
    <svg class="slds-button__icon" aria-hidden="true">
      <use xlink:href="../../../../assets/symbols.svg#add"></use>
    </svg>
    <span class="slds-assistive-text">{{ $t('general.add')}}</span>
  </button>
</div>
</template>
<script>
import Picklist from '../../../slds/Picklist'
export default {
  components: {
    Picklist
  },
  data () {
    return {
      selectedOffer: ''
    }
  },
  methods: {
    addOffer () {
      this.$emit('offerAdded', { offer: this.selectedOffer })
      this.selectedOffer = ''
    }
  },
  props: {
    editable: Boolean,
    offers: Array
  }
}
</script>
<style lang="scss" scoped>
  .offers-picklist {
    display: flex;
    flex-direction: row;
  }
</style>
